// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterWrapper {
  background-color: #fff;
  border-radius: 10px;
  padding: 24px;
  margin: 24px;
}
.filterWrapper > div {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px 16px;
}

.dailyAttendanceSheetWrapper {
  background-color: #fff;
  border-radius: 10px;
  padding: 24px;
  margin: 24px;
}

.submitBtnWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 30px 10px;
  gap: 16px;
}

.headerEdit,
.headerLogs {
  display: flex;
  align-items: center;
  gap: 12px;
}
.headerEdit > p {
  margin-bottom: 0px;
  font-size: 20px;
  font-weight: 600;
}

.headerLogs > p {
  margin-bottom: 0px;
  font-size: 20px;
  font-weight: 600;
}

.headerEdit > :nth-child(1) {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(24, 144, 255, 0.1);
  border-radius: 20px;
}
.headerLogs > :nth-child(2) {
  cursor: pointer;
  text-decoration: underline;
  color: var(--supportRed);
}

.tabAccessTableWrapper > table {
  width: 100%;
  table-layout: fixed;
  overflow-x: auto;
  border-radius: 10px !important;
}

.tabAccessTableWrapper > table td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid var(--lightBlue);
  text-align: center;
}

.tabAccessTableWrapper > table > tbody td {
  font-weight: 600;
  padding: 10px 8px;
}

/* --------------- Media Query ------------------ */
@media (max-width: 1300px) {
  .filterWrapper > div {
    grid-template-columns: repeat(3, 1fr);
  }
  .tabAccessTableWrapper > table {
    width: 100%;
  }
}
@media (max-width: 1000px) {
  .filterWrapper > div {
    grid-template-columns: repeat(2, 1fr);
  }
  .tabAccessTableWrapper > table {
    width: 100%;
  }
  .tabAccessTableWrapper {
    overflow-x: auto;
    padding: 10px;
    display: block;
  }
  .tabAccessTableWrapper > table {
    width: 100%;
  }
  .tabAccessTableWrapper p {
    font-size: 14px !important;
  }
}

@media (max-width: 750px) {
  .filterWrapper {
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    margin: 10px;
  }

  .dailyAttendanceSheetWrapper {
    padding: 10px;
    margin: 10px;
  }
  .tabAccessTableWrapper > table > tbody td {
    font-size: 14px !important;
  }
}

@media (max-width: 450px) {
  .filterWrapper > div {
    grid-template-columns: repeat(1, 1fr);
  }
}

/* User Log Timeline Styles */
.userLogPageWrapper {
  background-color: #ffffff;
  padding: 10px;
  min-height: 100vh;
}

.userLogContentBox {
  background-color: #f0f4f8; /* the light blue grey */
  padding: 40px;
  position: relative;
  overflow: hidden;
  margin: 0 auto 30px auto;
  max-width: 1000px;
  min-height: 850px; /* Ensures the 750px SVG always fits */
  border-radius: 20px;
}

.userLogWatermark {
  position: absolute;
  top: 60px; /* Always stay at the top */
  left: 50%;
  transform: translateX(-50%); /* Only center horizontally */
  width: 750px;
  pointer-events: none;
  z-index: 0;
}

/* Header */
.userLogHeaderWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.userLogCloseBtnTop {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: #313893;
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s;
}

.userLogCloseBtnTop:hover {
  background-color: #262c72;
}

.userLogHeaderTitle {
  font-size: 20px;
  font-weight: 700;
  color: #3b3ea3;
  padding-bottom: 6px;
  border-bottom: 2px solid #c2c9d6; /* Subtle grey-blue underline */
  display: inline-block;
  margin: 0;
  min-width: 120px;
  text-align: center;
}

/* Timeline Container */
.timelineWrapper {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  padding-left: 20px;
  z-index: 1;
}

.timelineLine {
  position: absolute;
  left: 26px; /* Align to center of dot */
  top: 25px;
  bottom: 25px;
  width: 1px;
  background-color: #94a3b8;
  z-index: 1;
}

.timelineItem {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 0;
}

.timelineDot {
  position: absolute;
  left: -2px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  background-color: #028459;
  border-radius: 50%;
  z-index: 2;
}

.timelineContent {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 40px;
  padding: 16px 0;
  border-bottom: 1px solid #e2e8f0;
}

.timelineItem:last-child .timelineContent {
  border-bottom: none;
}

.timelineSection {
  display: flex;
  align-items: center;
}

.timelineCol1 {
  flex: 0 0 25%;
}

.timelineCol2 {
  flex: 0 0 50%;
  justify-content: center;
}

.timelineCol3 {
  flex: 0 0 25%;
  justify-content: flex-end;
}

.timelineLabel {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-right: 8px;
}

.timelineDesignationBadge {
  background-color: #3b3ea3;
  color: #ffffff;
  padding: 4px 18px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.timelineText {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
}

.timelineDivider {
  margin: 0 16px;
  color: #94a3b8;
  font-size: 14px;
}
/* User Log Responsive Styles */
@media (max-width: 768px) {
  .userLogPageWrapper {
    padding: 15px;
  }
  .userLogContentBox {
    padding: 20px 15px;
    border-radius: 12px;
  }
  .userLogHeaderTitle {
    font-size: 16px;
  }
  .userLogCloseBtnTop {
    padding: 6px 12px;
    font-size: 12px;
  }
  .timelineContent {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 16px 0;
  }
  .timelineCol1,
  .timelineCol2,
  .timelineCol3 {
    flex: 1 1 auto;
    width: 100%;
    justify-content: flex-start;
  }
  .timelineDivider {
    margin: 0 8px;
  }
  .userLogWatermark {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContractorUsers/user.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE;IACE,qCAAqC;EACvC;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB,EAAE,sCAAsC;EACzD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,2BAA2B;EACtC,SAAS;EACT,2BAA2B,EAAE,6BAA6B;EAC1D,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC,EAAE,+BAA+B;EACjE,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,2BAA2B;EACvC,SAAS;EACT,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;EACA;;;IAGE,cAAc;IACd,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".filterWrapper {\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 24px;\n  margin: 24px;\n}\n.filterWrapper > div {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px 16px;\n}\n\n.dailyAttendanceSheetWrapper {\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 24px;\n  margin: 24px;\n}\n\n.submitBtnWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 30px 10px;\n  gap: 16px;\n}\n\n.headerEdit,\n.headerLogs {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.headerEdit > p {\n  margin-bottom: 0px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.headerLogs > p {\n  margin-bottom: 0px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.headerEdit > :nth-child(1) {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(24, 144, 255, 0.1);\n  border-radius: 20px;\n}\n.headerLogs > :nth-child(2) {\n  cursor: pointer;\n  text-decoration: underline;\n  color: var(--supportRed);\n}\n\n.tabAccessTableWrapper > table {\n  width: 100%;\n  table-layout: fixed;\n  overflow-x: auto;\n  border-radius: 10px !important;\n}\n\n.tabAccessTableWrapper > table td {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  border: 1px solid var(--lightBlue);\n  text-align: center;\n}\n\n.tabAccessTableWrapper > table > tbody td {\n  font-weight: 600;\n  padding: 10px 8px;\n}\n\n/* --------------- Media Query ------------------ */\n@media (max-width: 1300px) {\n  .filterWrapper > div {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .tabAccessTableWrapper > table {\n    width: 100%;\n  }\n}\n@media (max-width: 1000px) {\n  .filterWrapper > div {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .tabAccessTableWrapper > table {\n    width: 100%;\n  }\n  .tabAccessTableWrapper {\n    overflow-x: auto;\n    padding: 10px;\n    display: block;\n  }\n  .tabAccessTableWrapper > table {\n    width: 100%;\n  }\n  .tabAccessTableWrapper p {\n    font-size: 14px !important;\n  }\n}\n\n@media (max-width: 750px) {\n  .filterWrapper {\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 10px;\n    margin: 10px;\n  }\n\n  .dailyAttendanceSheetWrapper {\n    padding: 10px;\n    margin: 10px;\n  }\n  .tabAccessTableWrapper > table > tbody td {\n    font-size: 14px !important;\n  }\n}\n\n@media (max-width: 450px) {\n  .filterWrapper > div {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n/* User Log Timeline Styles */\n.userLogPageWrapper {\n  background-color: #ffffff;\n  padding: 10px;\n  min-height: 100vh;\n}\n\n.userLogContentBox {\n  background-color: #f0f4f8; /* the light blue grey */\n  padding: 40px;\n  position: relative;\n  overflow: hidden;\n  margin: 0 auto 30px auto;\n  max-width: 1000px;\n  min-height: 850px; /* Ensures the 750px SVG always fits */\n  border-radius: 20px;\n}\n\n.userLogWatermark {\n  position: absolute;\n  top: 60px; /* Always stay at the top */\n  left: 50%;\n  transform: translateX(-50%); /* Only center horizontally */\n  width: 750px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Header */\n.userLogHeaderWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  position: relative;\n  z-index: 1;\n}\n\n.userLogCloseBtnTop {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #313893;\n  color: #ffffff;\n  border: none;\n  padding: 8px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.userLogCloseBtnTop:hover {\n  background-color: #262c72;\n}\n\n.userLogHeaderTitle {\n  font-size: 20px;\n  font-weight: 700;\n  color: #3b3ea3;\n  padding-bottom: 6px;\n  border-bottom: 2px solid #c2c9d6; /* Subtle grey-blue underline */\n  display: inline-block;\n  margin: 0;\n  min-width: 120px;\n  text-align: center;\n}\n\n/* Timeline Container */\n.timelineWrapper {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  padding-left: 20px;\n  z-index: 1;\n}\n\n.timelineLine {\n  position: absolute;\n  left: 26px; /* Align to center of dot */\n  top: 25px;\n  bottom: 25px;\n  width: 1px;\n  background-color: #94a3b8;\n  z-index: 1;\n}\n\n.timelineItem {\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin-bottom: 0;\n}\n\n.timelineDot {\n  position: absolute;\n  left: -2px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  background-color: #028459;\n  border-radius: 50%;\n  z-index: 2;\n}\n\n.timelineContent {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-left: 40px;\n  padding: 16px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.timelineItem:last-child .timelineContent {\n  border-bottom: none;\n}\n\n.timelineSection {\n  display: flex;\n  align-items: center;\n}\n\n.timelineCol1 {\n  flex: 0 0 25%;\n}\n\n.timelineCol2 {\n  flex: 0 0 50%;\n  justify-content: center;\n}\n\n.timelineCol3 {\n  flex: 0 0 25%;\n  justify-content: flex-end;\n}\n\n.timelineLabel {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-right: 8px;\n}\n\n.timelineDesignationBadge {\n  background-color: #3b3ea3;\n  color: #ffffff;\n  padding: 4px 18px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.timelineText {\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.timelineDivider {\n  margin: 0 16px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n/* User Log Responsive Styles */\n@media (max-width: 768px) {\n  .userLogPageWrapper {\n    padding: 15px;\n  }\n  .userLogContentBox {\n    padding: 20px 15px;\n    border-radius: 12px;\n  }\n  .userLogHeaderTitle {\n    font-size: 16px;\n  }\n  .userLogCloseBtnTop {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n  .timelineContent {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    padding: 16px 0;\n  }\n  .timelineCol1,\n  .timelineCol2,\n  .timelineCol3 {\n    flex: 1 1 auto;\n    width: 100%;\n    justify-content: flex-start;\n  }\n  .timelineDivider {\n    margin: 0 8px;\n  }\n  .userLogWatermark {\n    width: 90%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
